
/*
  Generated class for the GoogleAnalyticsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export class GoogleAnalyticsProvider {

  private _trackings: Array<any> = [];
  private _basePath: string = "";

  /**
   * gaを持っておく
   */
  constructor() {
  }

  /**
   * トラッキングIDを追加
   * 
   * @param trackingId 
   * @param trackingName 
   * @param asClient  //  お客様のトラッキングID判定
   */
  addTrackingId(trackingId, trackingName, asClient = false)
  {
    this._trackings.push({
      id: trackingId,
      name: trackingName,
      asClient: asClient,
    });
    let ga = window["ga"];
    ga('create', trackingId, 'auto', {
      name: trackingName
    });
  }

  /**
   * BasePathを設定
   * @param basePath 
   */
  setBasePath(basePath){
    this._basePath = basePath;
  }

  /**
   * PageViewを送信
   * 
   * @param page 
   * @param referrer
   */
  protected sendPageView(clientFilter, page, referrer = ""){
    let ga = window["ga"];
    console.warn("send pageiew " + page);
    console.warn("with referrer :" + referrer);
    this._trackings.forEach(tid => {
      if (tid.asClient && clientFilter) return;
      console.warn("send pageiew for "+tid.name+" : "+tid.id);
      if (referrer.length > 0){
        ga(`${tid.name}.set`, 'referrer', referrer);
      }
      ga(`${tid.name}.set`, 'page', `${this._basePath}${page}`);
      ga(`${tid.name}.send`, 'pageview');
    });
  }

  /**
   * イベント送信
   * 
   * @param eventCategory 
   * @param eventAction 
   * @param eventLabel 
   * @param eventValue 
   */
  protected sendEvent(eventCategory, eventAction, eventLabel = "", eventValue = ""){
    let ga = window["ga"];
    var eventObj = {
      hitType: "event",
      eventCategory: eventCategory,
      eventAction: eventAction,
    }
    if (eventLabel.length > 0){
      eventObj["eventLabel"] = eventLabel;
    }
    if (eventValue.length > 0){
      eventObj["eventValue"] = eventValue;
    }
    this._trackings.forEach(tid => {
      ga(`${tid.name}.send`, eventObj);
      console.log("sendEvent tid"); console.log(tid);
    });
    console.log("sendEvent this._trackings"); console.log(this._trackings);
  }
}



// WEBPACK FOOTER //
// ./src/providers/google-analytics/google-analytics.ts